import * as yup from "yup";
import {stringNullable, stringNullableRequired} from "yup/defaultValudations";

export const schema = yup.object().shape({
  name: stringNullableRequired(),
  number: stringNullable(),
  supplierName: stringNullableRequired(),
  SupplierId: stringNullable().when("supplierName", (supplierName, schema) =>
    supplierName ? schema : schema.required()
  ),
  date: stringNullableRequired(),
  ProjectId: stringNullable(),
  ProjectItemId: stringNullable(),
  documents: yup.array().min(1).required(),
  notes: stringNullable(),
});

export const initialValues = {
  name: null,
  number: null,
  date: null,
  SupplierId: null,
  supplierName: null,
  ProjectId: null,
  ProjectItemId: null,
  documents: [],
  notes: null,
};
